import { IComponentController } from 'angular';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import IDialogService = angular.material.IDialogService;

interface IPageAl2011 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    dlaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dlaMultiOccurrence: IMultiOccurrence;
}

/* @ngInject */
export default function Al2011Controller(
    MenuItemAction: IMenuItemActionClass,
    $mdDialog: IDialogService) {

    const vm: IPageAl2011 = this;

    const menuItemRepartition = new MenuItemAction(
        '',
        'BOUACTABS',
        (data: any) => ({
            dlhcleint: data.dlhcleint,
            dlacleint: data.dlacleint
        }),
        {
            icon: (data: any) => {
                if (!data.dlaflggenabs) {
                    return 'radio_button_unchecked';
                } else return 'check_circle';
            },
            successAction: () => {
                vm.dlaMultiOccurrence.fetchDataList();
            }
        }
    );
    vm.monoOccurrenceOptions = {
        fonctions: {
            afficherMenusDansEntete: true
        },
        menus: [
            new MenuItemAction('LBL_BTN_GEN', 'BOUGEN', () => ({}), {
                fonction: 'BOUGEN',
                saveFirst: true,
                iconButton: false,
                class: 'md-raised ex-button-action',
                successAction: () => {
                    $mdDialog.hide();
                }
            })
        ]
    };
    vm.dlaMultiOccurrenceOptions = {
        fonctions: {
            suiviModification: false
        },
        colonnesFixesGauche: [{ nom: 'dlaflggenabs', menu: [menuItemRepartition], replacedValue: ' ', largeur: 90 }],
        colonnesVisibles: [
            { nom: 'aftcod', largeur: 104 },
            { nom: 'aftdscfmt', largeur: 280 },
            { nom: 'dlaqte', largeur: 87 },
            { nom: 'dladursem', largeur: 100 },
            { nom: 'dlaflgremaut', largeur: 113 }
        ]
    };
}
